import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLayoutToActivePage } from '../../redux/actions/entities/pages';

import './Layout.css';
import {
  calculateRatio,
  GetActivePage,
  hasEmptyPlaceholder,
} from '../../redux/helpers/index';


class Layout extends Component {
  isMobile = () => window.innerWidth <= 991 ? true : false;

  constructor(...args) {
    super(...args);
    this.state = {
      isRendering: false,
      originalLayoutBoxHeight: 0,
      isMobile: this.isMobile(),
    };
    this.originalLayoutBoxHeight = 0;
    this.startRendering = this.startRendering.bind(this);
    this.stopRendering = this.stopRendering.bind(this);
  }

  componentDidMount() {
    this.setLayoutBoxHeight();
    window.addEventListener('resize', this.getWindowWidth);
  }

  getWindowWidth = () => {
    this.setState({
      ...this.state,
      isMobile: this.isMobile(),
    })
  }

  setLayoutBoxHeight = () => {
    const { layoutHeight } = this.props.bookProperties;
    this.setState({
      ...this.state,
      originalLayoutBoxHeight: layoutHeight,
    });
  }


  setLayout = () => {
    this.startRendering();
    this.setDebounce();
    if (!this.state.isRendering) {
      const {
        id,
        pages,
        lang,
        allPlaceholders,
      } = this.props;


      const getActivePage = GetActivePage(pages);
      const activePageId = getActivePage.id;
      const activePageLayout = getActivePage.layout;

      if (hasEmptyPlaceholder(getActivePage, allPlaceholders, lang)) {
        return;
      }


      if (id !== activePageLayout) {
        this.props.dispatch(setLayoutToActivePage(id, activePageId, false, false));
      }
    }
    return true;
  }

  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 1500);
  }

  startRendering() {
    this.setState({ 
      ...this.state,
      isRendering: true
     });
  }

  stopRendering() {
    this.setState({ 
      ...this.state,
      isRendering: false
     });
  }

  renderPlaceholders() {
    const {
      placeholders,
      height,
      isCover,
      pages,
      layouts,
      isFrontFlyleaf,
      isBackFlyleaf,
    } = this.props;


    const activePage = Object.values(pages).find(element => element.isActive);
    const activeLayout = layouts[activePage.layout];

    if (!activeLayout) {
      return;
    }

    const calculatedPlaceholders = placeholders ?
      placeholders.map((key, index) => {
        if (key.width === 0 && key.height === 0 && (isFrontFlyleaf || isBackFlyleaf)) {
          return <p key={index} className="blankflyleaf">Blank</p>;
        }

        if (key.width === 0 && key.height === 0 && isCover) {
          return '';
        }

        const ratio = isCover ? height / this.props.layouts[this.props.id].height : (this.state.isMobile ? (height / this.state.originalLayoutBoxHeight)/2 : (height / this.state.originalLayoutBoxHeight));
        const placeholderStyles = calculateRatio(ratio, key);
        return <div key={index} style={placeholderStyles} />;
      }) : '';

    return calculatedPlaceholders;
  }

  render() {
    const {
      height,
      width,
      isCover,
      isBabyPlaceholder,
      isBlank,
    } = this.props;

    const style = {
      height: this.state.isMobile ? height/2 : height,
      width: this.state.isMobile ? width/2 : width,
    };

    const hideEmptyBabyPlaceholder = isBabyPlaceholder && isBlank;

    if ((hideEmptyBabyPlaceholder) || (isCover && this.renderPlaceholders() && this.renderPlaceholders()[0] === '')) {
      return false;
    }

    return (
      <div className="Layout" style={style} role="presentation" onClick={event => this.setLayout(event)}>
        { this.renderPlaceholders() }
      </div>
    );
  }
}

Layout.defaultProps = {
  placeholders: [],
  height: 0,
  isCover: false,
  width: 0,
  id: 0,
  isFrontFlyleaf: false,
  isBackFlyleaf: false,
  pages: {},
  bookProperties: {},
  lang: {},
  layouts: {},
  dispatch: () => {},
  isBabyPlaceholder: false,
};

Layout.propTypes = {
  placeholders: PropTypes.array,
  height: PropTypes.number,
  isCover: PropTypes.bool,
  width: PropTypes.number,
  id: PropTypes.number,
  isFrontFlyleaf: PropTypes.bool,
  isBackFlyleaf: PropTypes.bool,
  pages: PropTypes.object,
  bookProperties: PropTypes.object,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  dispatch: PropTypes.func,
  isBabyPlaceholder: PropTypes.bool,
};


export default connect(state => ({
  isChange: state.editorUI.imageChange.isChange,
  bookProperties: state.bookProperties.dimensions,
  bookId: state.bookProperties,
  layouts: state.entities.layouts.byId,
  allPlaceholders: state.entities.placeholders.byId,
}
))(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/Layout.jsx